import { render } from "./SeccionProdsDestacar.vue?vue&type=template&id=131f5036&scoped=true"
import script from "./SeccionProdsDestacar.vue?vue&type=script&lang=js"
export * from "./SeccionProdsDestacar.vue?vue&type=script&lang=js"

import "./SeccionProdsDestacar.vue?vue&type=style&index=0&id=131f5036&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131f5036"]])

export default __exports__